
import Vue from 'vue';
import { namespace } from 'vuex-class';
import { Component, Prop } from 'vue-property-decorator';

import { provideEventSpinningText, getSpinningTextVars } from '@/components/sports/common/event/event-spinning-text';

import { SportEventV2, SportEventStatus } from '@/@types/graphql-types';

const Language = namespace('language');

@Component({ name: 'EventSpinningText' })
export default class EventSpinningText extends Vue {
	@Prop({ required: true }) event: SportEventV2;
	@Prop({ required: true }) eventTitle: string;
	@Prop() status: SportEventStatus;
	@Prop() date: string;
	@Prop() time: string;

	@Language.Getter language: string;

	get spinningText() {
		const { heading, content } = provideEventSpinningText(
			this.status,
			this.eventTitle,
			this.date,
			this.event.offers
		);
		return {
			heading: this.$t(heading, this.spinningTextVars),
			content: content.map(text => this.$t(text, this.spinningTextVars)).join(' '),
		};
	}

	get spinningTextVars() {
		return getSpinningTextVars(
			this.language,
			this.event.offers,
			this.event.watchNowOffer,
			this.eventTitle,
			this.$t(`SPORTS_WEBAPP_SPORT_TYPE_${this.$route.meta!.sport}`).toString(),
			this.date,
			this.time
		);
	}
}
